import { t } from '@transifex/native';

import * as flashActions from 'pkg/actions/flashes';

import * as endpoints from 'pkg/api/endpoints/auto';
import type * as models from 'pkg/api/models';
import { create } from 'pkg/api/models/actions';
import * as sdk from 'pkg/core/sdk';

interface AccountRelationsCreatePayload {
	type: string;
	email: string;
}

export async function createRequest(
	type: string,
	email: string
): Promise<[Response, any]> {
	const [request, response, error] = await create<
		AccountRelationsCreatePayload,
		models.accountRelation.AccountRelation
	>(endpoints.AccountRelations.Create(), { type, email });

	if (!request.ok) {
		flashActions.show(
			{
				title: t('Something went wrong'),
				message: error.error,
			},
			request.status
		);

		return [request, response];
	}

	flashActions.show(
		{
			title: t(`Request sent`),
			message: t(`Request sent to {userEmail}`, {
				userEmail: email,
			}),
		},
		request.status
	);

	return [request, response];
}

export async function approveRequest(
	accountRelationId: number
): Promise<boolean> {
	const request = await sdk.post(
		endpoints.AccountRelations.Approve(accountRelationId)
	);

	if (!request.ok) {
		flashActions.show(
			{
				title: t('Something went wrong'),
			},
			request.status
		);

		return false;
	}

	return true;
}

export async function remove(accountRelationId: number): Promise<void> {
	await sdk.destroy(endpoints.AccountRelations.Delete(accountRelationId));
}
